import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=4ed76950&scoped=true"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed76950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed76950')) {
      api.createRecord('4ed76950', component.options)
    } else {
      api.reload('4ed76950', component.options)
    }
    module.hot.accept("./AddCoupon.vue?vue&type=template&id=4ed76950&scoped=true", function () {
      api.rerender('4ed76950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/applet/dialogs/AddCoupon.vue"
export default component.exports